import { executeRequest, JFSRequest } from '@jfs/network'
import { clean, getIdFromMap, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequest = (reqObj: any) => {
  const data = clean(reqObj)
  return {
    chiper: data?.chiper,
    entityId: getIdFromMap(data?.entityId),
    id: data?.id,
    instrumentType: getIdFromMap(data?.instrumentType),
    mcfg1: data?.mcfg1,
    mcfg2: data?.mcfg2,
    meCode: data?.meCode,
    merchantId: data?.merchantId,
    pgSecurityId: data?.pgSecurityId,
    secret: data?.secret,
    reqType: data?.reqType,
    txnType: getIdFromMap(data?.txnType),
    emiCode: data?.emiCode,
    offerCode: data?.offerCode,
    productId: data?.productId,
    mappingStatus:
      data?.mappingStatus?.toLowerCase() === 'deactivate' || data?.mappingStatus?.toLowerCase() === 'false'
        ? 'false'
        : 'true',
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateMerchantMapping = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateMerchantMapping),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateMerchantMapping }
